import { render, staticRenderFns } from "./AddSaleRate.vue?vue&type=template&id=52415d17&"
import script from "./AddSaleRate.vue?vue&type=script&lang=js&"
export * from "./AddSaleRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports